import {
  GetProductsByIdBatchedQuery,
  GetItemDataByIdQuery,
} from '@notino/shared/definitions/types';

import {
  GTM_LIST_LABEL,
  GTM_WISHLIST_PAGE_TYPE,
} from '@containers/WishList/constants';
import { dispatchTrackingEvent } from '@context/tracking/utils';
import {
  useGetMasterAddToCart,
  ProductEventWither,
} from '@helpers/googleTagManager';
import { useGetTrackMasterAddToCartFail } from '@helpers/googleTagManager/useGetTrackMasterAddToCartFail';

export const trackWishlistProductListImpression = (
  products: GetProductsByIdBatchedQuery['vpProductByIds'],
  productIds: string[],
  interaction: 'automatic' | 'button'
) => {
  const transformedProducts = products.map((product) =>
    ProductEventWither()
      .withVpProduct(product)
      .withAdditionalData({
        list_position: productIds.findIndex((id) => id === product.id) + 1,
      })
      .build()
  );

  dispatchTrackingEvent({
    event: 'view_item_list',
    _clear: true,
    product_lists: {
      list_name: GTM_LIST_LABEL,
      interaction,
      sorting_type: 'automatic',
      products: transformedProducts,
    },
  });
};

export const trackWishlistPageView = () => {
  dispatchTrackingEvent({
    event: 'page_view',
    page: {
      title: 'Wishlist',
      path: window.location.pathname,
      unified_name: 'wishlist',
      type: GTM_WISHLIST_PAGE_TYPE,
      subpage: undefined,
    },
    _clear: true,
  });
};

export const useTrackToCartAsync = (productIds: string[], listName: string) => {
  const trackAddToCart = useGetMasterAddToCart(listName);
  return async (product: GetItemDataByIdQuery['vpProductById']) => {
    await trackAddToCart(
      product,
      product.catalogMasterId.toString(),
      productIds.findIndex((id) => id === product.id) + 1
    );
  };
};

export const useTrackToCartFailedAsync = (
  productIds: string[],
  listName: string
) => {
  const track = useGetTrackMasterAddToCartFail(listName);
  return async (
    errorMessage: string,
    product: GetItemDataByIdQuery['vpProductById']
  ) => {
    await track(
      product,
      product.catalogMasterId.toString(),
      productIds.findIndex((id) => id === product.id) + 1,
      errorMessage
    );
  };
};
